var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMicrophone = function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m245.4 245.3-40 40c-5.9 5.9-5.9 15.4 0 21.2s15.4 5.9 21.2 0l40-40c5.9-5.9 5.9-15.4 0-21.2-5.8-5.8-15.3-5.8-21.2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M473.9 217.7c50.8-51 50.8-128.6-.1-179.5-51.1-51.1-129.3-50.7-179.6 0-29.4 29.6-41.2 69.4-35.9 107.4l-242 256.5c-22.3 23.8-21.7 60.4 1.4 83.4l8.8 8.8c23 23 59.7 23.6 83.5 1.3l256.5-242c40.8 5.8 81.2-9 107.4-35.9zM452.6 59.4c35.5 35.5 38.8 87.3 9.9 125.8L326.8 49.5c38.5-28.9 90.4-25.5 125.8 9.9zM89.4 473.8c-11.9 11.1-30.2 10.8-41.7-.7l-8.8-8.8c-11.5-11.5-11.8-29.8-.7-41.7l229.7-243.4c12.7 28.9 36 52.2 64.9 64.9L89.4 473.8zm226-277.2c-34.2-34.2-37.5-87.8-9.8-125.7l135.5 135.5c-37.8 27.6-91.4 24.4-125.7-9.8z"
  })));
};

export default SvgMicrophone;